import styled from "styled-components";
import { Button } from "../../../../../../base/buttons/button/index.js";
import { FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { SearcherItem } from "../../../styled.js";
import searcherButtonThemes from "./themes/index.js";
export const SearcherWrapperButtonMobile = styled(Button).withConfig({
    displayName: "styled__SearcherWrapperButtonMobile",
    componentId: "sc-fc56b8e4-0"
})`
	${FontMixin({
    size: 'large',
    weight: 'regular'
})}
	height: ${({ height ='56px'  })=>height};
	min-height: 52px;
	padding: 8px 16px;
	width: 100%;

	span {
		text-transform: none;
		${FontMixin({
    size: 'base',
    height: 'small'
})}
	}

	${searcherButtonThemes('SearcherWrapperButtonMobile')}
`;
export const SearcherItemButtonMobile = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemButtonMobile",
    componentId: "sc-fc56b8e4-1"
})`
	flex-basis: calc(100% - var(--division-gap));
	flex-grow: 1;
`;

//# sourceMappingURL=styled.js.map